import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';

import { validateExpiry } from './stripeValidator';

const getCreditCardExpiry = (
  eventInput: React.ChangeEvent<HTMLInputElement>,
) => {
  const { defaultValue, value } = eventInput.target;
  let isCreditCardExpiryValid = false;
  let creditCardExpiryErrorMessage = '';
  let creditCardExpiry = '';

  const digit = value.replace(/[^0-9/]|\s/g, '');

  if (defaultValue.length < value.length) {
    if (digit.length === 2) {
      creditCardExpiryErrorMessage =
        parseInt(value, 10) > 12 ? 'Mes inválido' : '';
      creditCardExpiry = `${digit}/`;
    } else if (digit.length === 4) {
      const year = digit.split('/')[1];

      creditCardExpiryErrorMessage =
        year && value.length === 4 && parseInt(year, 10) < 2
          ? 'Año inválido'
          : '';
      creditCardExpiry = digit;
    } else {
      creditCardExpiry = digit;
    }
  } else {
    creditCardExpiry = digit;
  }

  const validator =
    (window.Stripe && window.Stripe.validateExpiry) || validateExpiry;

  if (validator(creditCardExpiry)) {
    isCreditCardExpiryValid = !!(creditCardExpiry.length === 5);
  } else if (creditCardExpiry.length === 5) {
    creditCardExpiryErrorMessage = I18N_STRINGS.INVALID_EXPIRATION_DATE;
  }

  return {
    creditCardExpiry,
    isCreditCardExpiryValid,
    creditCardExpiryErrorMessage,
  };
};

export default getCreditCardExpiry;

export const validateCardExpiry = (
  eventInput: React.ChangeEvent<HTMLInputElement>,
) => {
  const {
    creditCardExpiry,
    isCreditCardExpiryValid,
    creditCardExpiryErrorMessage,
  } = getCreditCardExpiry(eventInput);

  let errorMessage = creditCardExpiryErrorMessage;

  if (creditCardExpiry === '') {
    errorMessage = I18N_STRINGS.REQUIRED_EXPIRATION_DATE;
  } else if (creditCardExpiry.length < 5) {
    errorMessage = I18N_STRINGS.INVALID_EXPIRATION_DATE;
  }

  return {
    creditCardExpiry,
    isCreditCardExpiryValid,
    creditCardExpiryErrorMessage: errorMessage,
  };
};
